export const data = [
  {
    title: 'Como se cadastrar no Programa de Leroy Merlin com Você?',

    text:
      'Para se cadastrar no Programa de Fidelidade Leroy Merlin com Você, basta acessar o site <a href="/fidelidade">www.leroymerlin.com.br/fidelidade</a> ou entrar no App, na aba "Programa de Fidelidade", clicar em “começar e aproveitar” e seguir o passo a passo. Antes de realizar o cadastro no programa, é preciso se cadastrar no site também.'
  },

  {
    title: 'O que é o vale-compras?',

    text:
      'O vale-compras é o cupom em dinheiro obtido através da troca de pontos. Para resgatá-lo é preciso ter 1.000 pontos para um vale-compras de R$10,00, 2.500 pontos para um vale-compras de R$35,00 e 7.500 pontos para um vale-compras de R$150,00. O vale-compras precisa ser ativado no site ou App, dentro do perfil logado do Programa de Fidelidade. Após a ativação, o vale-compras tem o prazo de validade de 30 dias.'
  },

  {
    title: 'O que é o “Minhas Vantagens”?',

    text:
      'O Minhas Vantagens é a parte do site ou App em que ficam os cupons de desconto em porcentagem concedidos pelo Programa de Fidelidade. Para resgatá-los basta clicar em “Ativar” dentro do perfil logado do Leroy Merlin com Você. Não é preciso utilizar pontos para ativá-los.'
  },

  {
    title: 'Como redefinir a senha cadastrada no site?',

    text:
      'Para alterar a senha cadastrada no site da Leroy Merlin é preciso clicar no botão “esqueceu a senha? ”, preencher o campo disponível com o e-mail ou o CPF cadastrados e aperta o botão enviar. O link para redefinir a senha será encaminhado para o e-mail registrado no site em até 24 horas.'
  },

  {
    title: 'O que fazer caso tenha esquecido o e-mail que está cadastrado na Leroy Merlin?',

    text:
      'Para fazer a troca do e-mail cadastrado no site da Leroy Merlin é preciso entrar em contato com a Central de Atendimento, através do número 4020-5376 para capital ou 0800-020-5376 para as demais regiões, e solicitar a troca de e-mail.'
  },

  {
    title: 'Por quais canais de compras é possível adquirir pontos?',

    text:
      'Para receber pontos é preciso se cadastrar no Leroy Merlin com Você e comprar na Leroy Merlin através da loja física, e-commerce, televendas, marketplace ou App, identificando a compra com o CPF. Não é possível acumular pontos em serviços e formas de pagamento como: Serviço de Instalação, Garantia Estendida, Vale-trocas, Frete, Cupom de desconto e Cartão Presente (será possível acumular pontos através do Cartão Presente apenas quando comprar e carregar o cartão).'
  },

  {
    title: 'Como acumular pontos no Programa de Fidelidade?',

    text:
      'Para acumular pontos é necessário estar cadastrado no Leroy Merlin com Você e fazer compras na Leroy Merlin, identificando-as com o CPF antes do registro dos produtos. A cada R$1,00 em compras, você recebe 1 ponto (R$1,00 = 1 ponto), sendo que centavos serão desprezados no cálculo dos pontos a serem atribuídos.'
  },

  {
    title: 'Qual o prazo para receber os pontos no perfil logado do LMCV?',

    text:
      'Os pontos serão atribuídos a conta em até 5 dias após a realização da compra. É possível acompanhar a pontuação dentro do perfil logado no site <a href="www.leroymerlin.com.br/fidelidade">leroymerlin.com.br/fidelidade</a> ou no App, na aba “Meus Pontos”, dentro do campo “Saldo de pontos”.'
  },

  {
    title:
      'Quantos pontos são necessários para resgatar um vale-compras (voucher fidelidade)?',

    text:
      'Dentro do perfil logado do programa de fidelidade Leroy Merlin com Você, é possível resgatar vale-compras de R$ 10,00 com 1.000 pontos, vale-compras de R$ 35,00 com 2.500 pontos ou vale-compras de R$ 150,00 com 7.500 pontos.'
  },

  {
    title: 'Os pontos são acumulativos?',

    text:
      'Sim. Todas as vezes que são feitas compras na Leroy Merlin, os pontos são acumulados dentro do perfil logado do programa de fidelidade Leroy Merlin com Você.'
  },

  {
    title: 'Como trocar os pontos por um vale-compras?',

    text:
      'O resgate de vale-compras utilizando pontos é feito no site <a href="www.leroymerlin.com.br/fidelidade">leroymerlin.com.br/fidelidade</a> ou no App, dentro do perfil logado. Para ter acesso aos descontos disponíveis é preciso entrar na aba “Meus Pontos” e rolar a tela até o título “Troque”. A pontuação mínima para resgatar um vale-compras é 1.000 pontos.'
  },

  {
    title: 'Como ativar o vale-compras ou benefício?',

    text:
      'Para ativar o vale-compras ou o cupom de desconto é preciso entrar na aba “Troque”, para vale-compras utilizando pontos, e “Minhas Vantagens”, para ativar os descontos concedidos pelo Programa de Fidelidade. Após essa dinâmica, basta clicar em “ativar” e confirmar a ativação.'
  },

  {
    title: 'É preciso utilizar pontos para ativar um benefício?',

    text:
      'Não é preciso utilizar pontos para resgatar um benefício em porcentagem concedido pela Leroy Merlin com Você. É preciso utilizar pontos apenas para resgate de vale-compras (voucher fidelidade) em dinheiro.'
  },

  {
    title:
      'Quanto tempo leva para o vale-compras aparecer ativo?',

    text:
      'O vale-compras pode ser utilizado a qualquer momento depois da ativação, desde que a compra seja identificada com o CPF antes do registro dos produtos.'
  },

  {
    title:
      'Após o resgate, qual o prazo para utilização do vale-compras?',

    text:
      'O vale-compras tem o prazo de 30 dias para ser utilizado. Após o período, o voucher e os pontos utilizados para adquiri-lo são expirados.'
  },

  {
    title:
      'Qual o prazo para utilização dos descontos fornecidos pelo Leroy Merlin com Você?',

    text:
      'Os descontos têm o prazo de validade determinado no cupom. Após o período estabelecido, os vouchers saem automaticamente da conta.'
  },

  {
    title: 'O que acontece com os pontos que passaram da data de validade?',

    text:
      'Os pontos que passaram da data de validade são retirados automaticamente da conta e não podem ser resgatados.'
  },

  {
    title: 'Os pontos adquiridos podem ser doados para outra pessoa?',

    text:
      'Não. Os pontos adquiridos através das compras são pessoais e intransferíveis. Não é permitido a doação, transferência ou qualquer forma de troca de pontos entre Clientes.'
  },

  {
    title: 'Qual o prazo de validade dos pontos adquiridos nas compras?',

    text:
      'Os pontos são válidos até o último dia do ano seguinte a compra. Ex.: Se você fez uma compra dentro do ano 2020, os seus pontos serão válidos até o último dia de 2021, ou seja, 31/12/2021.'
  },

  {
    title:
      'O vale-compras (voucher fidelidade) pode ser utilizado para compras no site e no App?',

    text:
      'Sim. O vale-compras em dinheiro poderá ser utilizado como meio de pagamento em compras de produtos vendidos e entregues pela Leroy Merlin.'
  },

  {
    title:
      'O cupom de desconto em porcentagem pode ser utilizado para compras no site?',

    text:
      'Sim. O cupom de desconto em porcentagem poderá ser utilizado em compras no site e App.'
  },

  {
    title:
      'Os descontos concedidos pela Leroy Merlin dentro do programa de fidelidade podem ser utilizados em qualquer ponto de venda?',

    text:
      'Não. Os cupons de desconto concedidos pelo Programa de Fidelidade Leroy Merlin com Você dentro do site ou App podem ser utilizados apenas nas condições descritas no voucher.'
  },

  {
    title:
      'É possível utilizar o vale-compras, adquirido com os pontos, em qualquer loja?',

    text:
      'Sim. Após a ativação do vale-compras (voucher fidelidade) no site, basta identificar a compra com o CPF antes do registro dos produtos em qualquer loja e utilizar essa forma de pagamento.'
  },

  {
    title: 'É possível acompanhar o extrato de pontos dentro do site?',

    text:
      'Sim. Para isso, é preciso entrar no perfil logado do Programa de Fidelidade no site <a href="www.leroymerlin.com.br/fidelidade">leroymerlin.com.br/fidelidade</a> ou App, clicar na aba “Meus Pontos” e descer a tela até o título “Saldo de Pontos”. Nesta parte é possível verificar todos os pontos que foram adquiridos nas compras e os que foram utilizados para resgatar vale-compras.'
  },

  {
    title: 'Quais são os benefícios do Leroy Merlin Com Você?',

    text:
      'Os principais benefícios são os pontos acumulativos que podem ser trocados por vale-compras, a surpresa de aniversário, o convite para eventos, os workshops e cursos, e os descontos em seção, subseção e produto concedidos pela Leroy Merlin.'
  }
]
